export const homeFor = (user) => (user?.role === "therapeute" ? "/pro" : user?.role === "payeur" ? "/payeur" : user?.role === "etablissement" ? "/etablissement" : "/app");
